import React, { useState, useEffect } from "react";
import MembersIcon from "../../Images/MenuIconComp/MembersIcon";
import EventsIcon from "../../Images/MenuIconComp/EventsIcon";
import InvoiceIcon from "../../Images/MenuIconComp/InvoiceIcon";
import OrderIcon from "../../Images/MenuIconComp/OrderIcon";
import SettingIcon from "../../Images/MenuIconComp/SettingIcon";
import ReportsIcon from "../../Images/MenuIconComp/ReportsIcon";
import PositionsIcon from "../../Images/MenuIconComp/PositionsIcon";
import CommitteesIcon from "../../Images/MenuIconComp/CommitteesIcon";

import { Link, useNavigate } from "react-router-dom";

import "../../Styles/MenuBarStyles.css";

import MenuBarItem from "./MenuBarItem";
import DownloadIcon from "../../Images/MenuIconComp/download";
import { useAppSelector } from "../../store/hooks";
import NewMemberIcon from "../../Images/MemberIconComp/NewMemberIcon";
import MemberIcon from "../../Images/MemberIconComp/MemberIcon";

const MenuBar: React.FC = () => {
  const [currentActiveButton, setCurrentActiveButton] =
    useState<string>("Members");
  const navigate = useNavigate();

  const callBack = (id: string) => {
    setCurrentActiveButton(id);
    console.log("currentActiveButton:", currentActiveButton);
  };

  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  const navigateToMenu = (menu: any) => {
    switch (menu) {
      case "invoice":
        if (
          !roleCapabilites.some((obj: any) =>
            Object.values(obj).includes("invoice.view")
          )
        ) {
          alert("No Access");
          return;
        }
        navigate("invoice", { replace: false });
        break;
      case "reports":
        if (
          !roleCapabilites.some((obj: any) =>
            Object.values(obj).includes("reports.view")
          )
        ) {
          alert("No Access");
          return;
        }
        navigate("reports", { replace: false });
        break;
      case "settings":
        if (
          !roleCapabilites.some((obj: any) =>
            Object.values(obj).includes("settings.view")
          )
        ) {
          alert("No Access");
          return;
        }
        navigate("settings", { replace: false });
        break;

      default:
        break;
    }
  };

  return (
    <div className="menubar-wrapper d-none d-lg-flex flex-column">
      <Link to="/member/findmember" className="menubar-link">
        <MenuBarItem
          id="Find Member"
          image={<MemberIcon height={40} width={37} />}
          alternate="Members"
          isActive={currentActiveButton == "Find Member" ? true : false}
          callBack={callBack}
        />
      </Link>
      <Link to="/member/create-member" className="menubar-link">
        <MenuBarItem
          id="Create Members"
          image={<NewMemberIcon height={40} width={40} />}
          alternate="Find Members"
          isActive={currentActiveButton == "Create Members" ? true : false}
          callBack={callBack}
        />
      </Link>
      <Link to="order" className="menubar-link">
        <MenuBarItem
          id="Orders"
          image={<OrderIcon height={40} width={37} />}
          alternate="Orders"
          isActive={currentActiveButton == "Orders" ? true : false}
          callBack={callBack}
        />
      </Link>
      <Link to="events" className="menubar-link">
        <MenuBarItem
          id="Events"
          image={<EventsIcon height={40} width={37} />}
          alternate="Accounts"
          isActive={currentActiveButton == "Events" ? true : false}
          callBack={callBack}
        />
      </Link>
      {/* <Link to="invoice" className="menubar-link"> */}
      <div onClick={() => navigateToMenu("invoice")}>
        <MenuBarItem
          id="Invoice"
          image={<InvoiceIcon height={40} width={37} />}
          alternate="Feed"
          isActive={currentActiveButton == "Invoice" ? true : false}
          callBack={callBack}
        />
      </div>
      {/* <Link to="reports" className="menubar-link"> */}
      {<div onClick={() => navigateToMenu("reports")}>
        <MenuBarItem
          id="Reports"
          image={<ReportsIcon height={40} width={37} />}
          alternate="Accounts"
          isActive={currentActiveButton == "Reports" ? true : false}
          callBack={callBack}
        />
      </div>}
      <Link to="positions" className="menubar-link">
        <MenuBarItem
          id="Positions"
          image={<PositionsIcon height={40} width={37} />}
          alternate="Positions"
          isActive={currentActiveButton == "Positions" ? true : false}
          callBack={callBack}
        />
      </Link>
      <Link to="committees" className="menubar-link">
        <MenuBarItem
          id="Committees"
          image={<CommitteesIcon height={40} width={37} />}
          alternate="Committees"
          isActive={currentActiveButton == "Committees" ? true : false}
          callBack={callBack}
        />
      </Link>
      {/* <Link to="settings" className="menubar-link"> */}
      <div onClick={() => navigateToMenu("settings")}>
        <MenuBarItem
          id="Settings"
          image={<SettingIcon height={40} width={37} />}
          alternate="Accounts"
          isActive={currentActiveButton == "Settings" ? true : false}
          callBack={callBack}
        />
      </div>
    </div>
  );
};

export default MenuBar;
